import CustomReasonSettingCard from './customReasonSettingCard.container';

export default CustomReasonSettingCard;